import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

export const useRoles = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getRoles = async () => {
      if (isAuthenticated) {
        try {
          const accessToken = await getAccessTokenSilently();
          const decodedToken = JSON.parse(atob(accessToken.split(".")[1]));
          const roles =
            decodedToken[process.env.REACT_APP_AUTH0_ROLES_CLAIM] || [];
          setRoles(roles);
        } catch (error) {
          console.error("Error decoding token:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    getRoles();
  }, [isAuthenticated, getAccessTokenSilently]);

  return {
    isAdmin: roles.includes("Admin"),
    isPartner: roles.includes("Partner"),
    roles,
    isLoading,
  };
};
